<template>
  <div class="carousel">
    <ButtonCarouselLeft
      v-if="areButtonsVisible"
      class="carousel-button-left"
      @click="handleClickLeft"
    />
    <div ref="carousel-content" class="carousel-content">
      <slot></slot>
    </div>
    <ButtonCarouselRight
      v-if="areButtonsVisible"
      class="carousel-button-right"
      @click="handleClickRight"
    />
  </div>
</template>
<script>
import ButtonCarouselLeft from 'UI/ButtonsCarousel/ButtonCarouselLeft.vue';
import ButtonCarouselRight from 'UI/ButtonsCarousel/ButtonCarouselRight.vue';
export default {
  components: {
    ButtonCarouselLeft,
    ButtonCarouselRight
  },
  props: {
    jumpsLength: {
      type: Number,
      default: 300,
      required: true
    }
  },
  data() {
    return {
      areButtonsVisible: false
    };
  },
  computed: {
    carouselRef() {
      return this.$refs['carousel-content'];
    }
  },
  mounted() {
    const carousel = this.carouselRef;
    const scrollWidth = carousel.scrollWidth;
    const offsetWidth = carousel.offsetWidth;
    if (scrollWidth !== offsetWidth) {
      this.areButtonsVisible = !this.areButtonsVisible;
    }
  },
  methods: {
    handleClickRight() {
      this.scroll({ descrease: false });
    },
    handleClickLeft() {
      this.scroll({ descrease: true });
    },
    scroll({ descrease }) {
      const carousel = this.carouselRef;
      const scrollLeft = carousel.scrollLeft;

      const leftScrollResolved = descrease
        ? scrollLeft - this.jumpsLength
        : scrollLeft + this.jumpsLength;

      const config = {
        top: 0,
        left: leftScrollResolved,
        behavior: 'smooth'
      };

      carousel.scroll(config);
    }
  }
};
</script>
<style lang="scss" scoped>
.carousel {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  .carousel-content {
    overflow-x: scroll;
    max-width: 100vw;
    grid-area: 1/1/2/4;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .carousel-button-left {
    z-index: 1;
    grid-area: 1/1/2/2;
  }
  .carousel-button-right {
    grid-area: 1/3/2/4;
  }
}
</style>
